import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const YouTube = forwardRef<SVGSVGElement, IconProps>(({ color, size = 20 }, forwardedRef) => {
  if (color) {
    return (
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2943_421)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5212 4.49036C17.2351 4.68368 17.7979 5.24982 17.9901 5.96786C18.3471 7.27965 18.3333 10.0137 18.3333 10.0137C18.3333 10.0137 18.3333 12.7339 17.9901 14.0457C17.7979 14.7638 17.2351 15.3299 16.5212 15.5232C15.2169 15.8684 10 15.8684 10 15.8684C10 15.8684 4.79688 15.8684 3.47893 15.5094C2.76504 15.3161 2.20217 14.75 2.00996 14.0319C1.66675 12.7339 1.66675 9.99989 1.66675 9.99989C1.66675 9.99989 1.66675 7.27965 2.00996 5.96786C2.20217 5.24982 2.77877 4.66987 3.47893 4.47656C4.78315 4.13135 10 4.13135 10 4.13135C10 4.13135 15.2169 4.13135 16.5212 4.49036ZM8.33984 7.48682L12.6781 9.99993L8.33984 12.5131V7.48682Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2943_421">
            <rect width="16.6667" height="13.3333" fill={color} transform="translate(1.66675 3.3335)" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_4_30)">
        <path
          d="M17.99 5.96778C17.7978 5.24974 17.235 4.6836 16.5211 4.49028C15.2169 4.13127 9.99996 4.13127 9.99996 4.13127C9.99996 4.13127 4.78307 4.13127 3.47885 4.47647C2.77869 4.66979 2.20208 5.24974 2.00988 5.96778C1.66667 7.27957 1.66667 9.99981 1.66667 9.99981C1.66667 9.99981 1.66667 12.7339 2.00988 14.0318C2.20208 14.7499 2.76496 15.316 3.47885 15.5093C4.7968 15.8684 9.99996 15.8684 9.99996 15.8684C9.99996 15.8684 15.2169 15.8684 16.5211 15.5231C17.235 15.3298 17.7978 14.7637 17.99 14.0457C18.3333 12.7339 18.3333 10.0136 18.3333 10.0136C18.3333 10.0136 18.347 7.27957 17.99 5.96778Z"
          fill="#FF0000"
        />
        <path d="M12.6781 9.99969L8.33984 7.48657V12.5128L12.6781 9.99969Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_4_30">
          <rect width="16.6667" height="13.3333" fill="white" transform="translate(1.66667 3.33333)" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default YouTube
